// import util from "@/util";
import moment from '@/moment-gp.js';
import $api from '@/api'
import $models from '@/models'
import clonedeep from 'lodash.clonedeep'

// eslint-disable-next-line
import TimeslotsWebWorker from 'worker-loader!@/workers/timeslots_web_worker.js';

const DEBUG_OUTPUT = false;
export const worker = TimeslotsWebWorker();

worker.onmessage = (event) => {
  if (event.data.status === 'ready') {
    $api.set_ready('timeslot_worker')
  }
}

function log() {
  if ( !DEBUG_OUTPUT ) { return; }
  let argumentsArray = [].slice.apply(arguments);
  console.log( ...argumentsArray );
}

function glog(sCallerName) {
  if ( !DEBUG_OUTPUT ) { return; }
  let argumentsArray = [].slice.apply(arguments);
  argumentsArray.shift();
  console.groupCollapsed('[timeslots/' + sCallerName + ']');
  if ( argumentsArray.length > 0 ) {
    log(...argumentsArray);
  }
  console.groupEnd();
}

function diff_time(to_time, from_time) {
  // TODO: to enhanced moment

  let to_time_split = to_time.split(':');
  let to_time_moment =  moment({ hour: to_time_split[0], minute: to_time_split[1] })

  let from_time_split = from_time.split(':');
  let from_time_moment =  moment({ hour: from_time_split[0], minute: from_time_split[1] })

  return moment.duration(to_time_moment.diff(from_time_moment));
}

export default {

  // TODO: getAreasAsCalendarEvents( calendarweek )

  // TODO: getRelatedEfforts( lifeareaId )

  /*
    Returns start date of current view
    */
  // get_view_range_start: state => state.view.range_start, --> calendar

  /*
    Returns horizon of current view
    */
  // get_view_horizon: state => state.view.horizon, --> calendar

  /*
    Return all timeslot collections (sorted and mapped)
  */
  /* timeslot_collection_list: (state, getters, rootState, rootGetters) => {
    glog("timeslot_collection_list");

    let user = rootGetters["user/userData"];
    // let user = rootState.user.userData;
    // log("user", user)

    // eslint-disable-next-line
    let dependencyFakeVariable = state.stateUpdateCounter * Math.random();
    // eigentlich von user abhängig?

    if (user && 'timeslotCollectionList' in user) {
      return Object.keys(user.timeslotCollectionList).map(key => {
        return { ...user.timeslotCollectionList[key], id: key };
      }).sort(util.sorter.by_sortidx);
    } else {
      return [];
    }
  }, */

  /*
    Return all timeslot collections
  */
  // weekday_preferences_by_timeslot_collection_id:
  // (state, getters, rootState, rootGetters) => tscId => {
  //   // glog("weekday_preferences_by_timeslot_collection_id", tscId)
  //
  //   let user = rootGetters["user/userData"];
  //   // let user = rootState.user.userData; // WTF?
  //   let timeslot_collection = user.timeslotCollectionList[tscId];
  //
  //   if (timeslot_collection && 'weekday_preferences' in timeslot_collection) {
  //     return timeslot_collection.weekday_preferences || [];
  //   } else {
  //     return [];
  //   }
  // },

  /*
    Return all timeslot collections (sorted and mapped/unpacked)
  */
  // weekday_preferences_by_timeslot_collection_id_sorted:
  // (state, getters, rootState) => tscId => {
  //   // glog('weekday_preferences_by_timeslot_collection_id_sorted', tscId)
  //
  //   let sortedPrefList = getters.weekday_preferences_by_timeslot_collection_id(tscId);
  //
  //   let num = 1;
  //   return Object.keys(sortedPrefList).map(key => {
  //     return { ...sortedPrefList[key], id: key, num: num++ };
  //   }).sort(util.sorter.by_sortidx);
  //
  //   // // let timeslot_collection_list = getters.timeslot_collection_list;
  //   // // let timeslot_collection = timeslot_collection_list[idx];
  //   // let user = rootState["user/userData"];
  //   // let timeslot_collection = user.timeslotCollectionList[tscId];
  //   //
  //   // // TODO: Validate
  //   //
  //   // if (timeslot_collection && 'weekday_preferences' in timeslot_collection) {
  //   //   const sortedPrefList = timeslot_collection.weekday_preferences;
  //   //
  //   //   return Object.keys(sortedPrefList).map(key => {
  //   //     return { ...sortedPrefList[key], id: key };
  //   //   }).sort(util.sorter.by_sortidx);
  //   // } else {
  //   //   return [];
  //   // }
  // },

  /*
    Return all exceptions (sorted and mapped/unpacked)
  */
  // exceptions_by_timeslot_collection_id_sorted:
  // (state, getters, rootState, rootGetters) => tscId => {
  //   // glog('exceptions_by_timeslot_collection_id_sorted', tscId)
  //
  //   let user = rootGetters["user/userData"];
  //   // let user = rootState.user.userData;
  //   let timeslot_collection = user.timeslotCollectionList[tscId];
  //
  //   if (timeslot_collection && 'exception_list' in timeslot_collection) {
  //
  //     let exceptionList = timeslot_collection.exception_list || [];
  //     let exceptionListCopy = Object.keys(exceptionList).map(key => {
  //       let exception = Object.assign({}, exceptionList[key]);
  //       // TODO: Once we store timezone neutral utc, converting is necessary here!
  //       if ( 'date' in  exception ) { exception.date = moment.fromRealtimeDB(exception.date); }
  //       if ( 'from' in  exception ) { exception.from = moment.fromRealtimeDB(exception.from); }
  //       if ( 'to'   in  exception ) { exception.to   = moment.fromRealtimeDB(exception.to  ); }
  //       return { ...exception, id: key };
  //     })
  //
  //     const dateSorter = (a, b) => {
  //       let leftDate = moment(a.date || a.from);
  //       let rightDate = moment(b.date || b.from);
  //       return leftDate.diff(rightDate)
  //     }
  //     exceptionListCopy.sort(dateSorter);
  //     return exceptionListCopy;
  //   } else {
  //     return [];
  //   }
  // },

  /*
  Return list of events derived from rules (weekday_prefs) and exceptions for
  ALL timeslot collections from a specific date to a given horizon.
  */
  flattened_calendar_data_all_with_start_and_horizon: (state, getters) =>
    (range_start, horizon) => {

    glog("flattened_calendar_data_all_with_start_and_horizon", range_start, horizon);

    // TODO: Selective Update -> DO NOT UPDATE WHEN NO CHANGE
    // maybe use this instead:
    //  getters.get_weekday_preferences_flat_cached(item.id)
    range_start = range_start.startOf('day')

    let mappedWeekdayPrefListFlat = {};
    // let tscList = getters.timeslot_collection_list;
    let tscList = $models.timeslotCollection.getList().itemsSorted;
    let tscRank = 0;
    let tscListLength = tscList.length
    for (let i = 0; i < tscListLength; i++) {
      let item = tscList[i]
    //tsc_list.forEach((item) => {
      /* increase rank by 1000 for tsc and by 1 for efforts/exceptions */
      // tscRank = tscRank + 1000;
      tscRank = tscRank + 1;
      mappedWeekdayPrefListFlat[item.$id] =
        getters.flattened_calendar_data_by_timeslot_collection_id(item.$id, range_start, horizon, 0)
      mappedWeekdayPrefListFlat[item.$id].rank = tscRank;
    }

    return mappedWeekdayPrefListFlat;
  },

  /*
  Return list of events derived from rules (weekday_prefs) and exceptions for
  ALL timeslot collections detect range_start and horizon from store settings.
  */
  flattened_calendar_data_all: (state, getters, rootState, rootGetters) => {
    glog("flattened_calendar_data_all");
    /* See flattened_calendar_data_all_one_day */
    // let user_timezone = rootGetters['user/user_get_timezone'];
    // let range_start = moment( getters.get_view_range_start ).tz(user_timezone());
    // let range_start = moment( getters.get_view_range_start );
    // let horizon     = getters.get_view_horizon;

    let visible_range = rootGetters["calendar/calendar_view_settings"].visible_range;
    let range_start   = visible_range.from_date;
    let horizon       = visible_range.horizon;

    // TODO: This should be converted to use the worker!
    // Depdenency tracking is already done by watcher.js
    // So whenever the worker is executed, we need to run a second workers
    // that has range_start and horizon set to the calendar view

    return getters.flattened_calendar_data_all_with_start_and_horizon( range_start, horizon );
  },

  // TODO: Action?
  worker_flattened_calendar_data_with_start_and_horizon: (state, getters, rootState, rootGetters) =>
    (range_start, planning_horizon) => {

    const log1 = (...args) => { console.log(...args) }
    // const log2 = (...args) => {}

    function mapGenericModelListToJSON( list ) {
      // MOVE to genericlist?
      return list.map(item => ({ $id: item.$id, ...item.$state })) // clonedeep?
    }

    const user_timezone = $models.userSettings.getters.user_get_timezone;
    // const tscList = getters.timeslot_collection_list;
    let tscList = $models.timeslotCollection.getList().itemsSorted;
    tscList = mapGenericModelListToJSON(tscList)

    // TODO: Delete tscList.exceptions and weekprefs?

    let weekday_preferences_by_tsc_id = {}
    let exceptions_by_tsc_id = {}

    tscList.map(tsc => {
      // TODO

      // clonedeep( tscList[ tsc.$id ].weekday_preferences )
      // let weekday_preferences = []
      // if ( $models.timeslotWeekdayPref.with({ timeslotCollectionId: tsc.$id }).exists() ) {
      //  weekday_preferences = $models.timeslotWeekdayPref.with({ timeslotCollectionId: tsc.$id }) ...
      // }
      let weekday_preferences = $models.timeslotWeekdayPref
        .getList()
        .itemsSorted
        .filter(weekdaypref => weekdaypref.tscId === tsc.$id )

      weekday_preferences = mapGenericModelListToJSON(weekday_preferences)
      weekday_preferences_by_tsc_id[ tsc.$id ] = weekday_preferences;

      // getters.weekday_preferences_by_timeslot_collection_id_sorted(tsc.$id)
    })

    // let weekday_preferences_by_tsc_id = tscList.map(tsc => {
    //   return weekday_preferences_by_timeslot_collection_id_sorted(tsc.$id)
    // })

    tscList.map(tsc => {
      // TODO:
      // let exceptions = getters.exceptions_by_timeslot_collection_id_sorted(tsc.$id)

      let exceptions = $models.timeslotException
        .getList()
        .itemsSorted
        .filter(exception => exception.tscId === tsc.$id )

      /*
      let exceptions = []
      if ( $models.timeslotException.with({ timeslotCollectionId: tsc.$id }).exists() ) {
        exceptions = $models.timeslotException.with({ timeslotCollectionId: tsc.$Id })
          .getList()
          .itemsSorted;
        exceptions = mapGenericModelListToJSON(exceptions)
      }
      */

      let exceptions_converted = exceptions.map(exception => {

        let exception_clone = clonedeep( exception.$state )
        exception_clone.$id = exception.$id;

        if (exception.$state.from) {
          exception_clone.from = exception.from.toOptimizer()
        }
        if (exception.$state.to) {
          exception_clone.to = exception.to.toOptimizer()
        }
        if (exception.$state.date) {
          exception_clone.date = exception.date.toOptimizer()
        }
        // exception.from = exception.from ? exception.from.toOptimizer() : null;
        // exception.to   = exception.to   ? exception.to.toOptimizer()   : null;
        // exception.date = exception.date ? exception.date.toOptimizer() : null;

        return exception_clone;
      })

      exceptions_by_tsc_id[tsc.$id] = exceptions_converted
    })

    // TODO: Convert GenericModel to ...

    let message = {
      range_start: range_start.toOptimizer(),
      planning_horizon: planning_horizon,
      weekday_preferences_by_timeslot_collection_id_sorted: weekday_preferences_by_tsc_id,
      exceptions_by_timeslot_collection_id_sorted: exceptions_by_tsc_id,
      tscList: tscList,
      user_timezone: user_timezone
    }

    console.log('[timeslot:worker] timeslots worker input message', message)

    // TODO: move only worker back to timeslot getters
    let t0 = performance.now();

    return new Promise((resolve, reject) => {

      // TODO: Check if this will only install one event listener
      worker.onmessage = (event) => {

        console.log("[timeslot:worker] Got results from timeslots web worker:", event);
        log1("[timeslot:worker] Calculation took " + Math.round(performance.now() - t0) + " ms")

        if (event.data.status === 'results') {
          resolve(event.data.results)
        } else {
          reject(new Error('No result'))
        }
      }

      worker.onerror = (error) => {
        reject(error)
      }

      worker.postMessage(message);
    });
  },

  /*
  Return list of events derived from rules (weekday_prefs) and exceptions for
  ALL timeslot collections for one day. (currently not used)
  */
  /*flattened_calendar_data_all_one_day: (state, getters, rootState, rootGetters) => {
    glog("flattened_calendar_data_all_one_day");

    // let user_timezone = rootGetters['user/user_get_timezone'];
    // let range_start = moment( getters.get_view_range_start ).tz(user_timezone());
    // let range_start = moment( getters.get_view_range_start );
    let visible_range = rootGetters["calendar/calendar_view_settings"].visible_range;
    let range_start   = visible_range.from_date;
    let horizon       = 1;
    return getters.flattened_calendar_data_all_with_start_and_horizon( range_start, horizon );
},*/

  /*
  Return list of events derived from rules (weekday_prefs) and exceptions for the
  collection identified by tscId (former: export_flat_weekday_list).
  */
  flattened_calendar_data_by_timeslot_collection_id: (state, getters, rootState, rootGetters) =>
    ( tscId, range_start, horizon, rank_offset ) => { // horizon, range_start

    glog("flattened_calendar_data_by_timeslot_collection_id", tscId)

    // eslint-disable-next-line
    // let dependencyFakeVariable = state.stateUpdateCounter * Math.random();

    // TODO: CHECK FOR OVERLAP --> async post function
    // TODO: Check what the tscId is and adapt to it

    // let weekday_preferences_sorted =
    //   getters.weekday_preferences_by_timeslot_collection_id_sorted(tscId);

    /*
    let weekday_preferences_sorted = []
    if ( $models.timeslotWeekdayPref.with({ timeslotCollectionId: tscId }).exists() ) {
      weekday_preferences_sorted =
        $models.timeslotWeekdayPref.with({ timeslotCollectionId: tscId })
        .getList()
        .itemsAsArray();
    }
    */
    let weekday_preferences_sorted = $models.timeslotWeekdayPref
      .getList()
      .itemsSorted
      .filter(weekdaypref => weekdaypref.tscId === tscId )

    // weekday_preferences_sorted = mapGenericModelListToJSON(weekday_preferences_sorted)

    //let range_start = moment( getters.get_view_range_start );
    //let horizon     = getters.get_view_horizon;
    let range_end   = moment( range_start ).add( horizon, 'd' );

    // log("## range_start", range_start.format('llll'));
    // log("## range_end", range_end.format('llll'));

    /* prune inactive */
    let pruned_weekday_preferences = [];
    let partly_pruned_weekday_preferences = [];
    // log("### weekday_preferences_sorted", weekday_preferences_sorted);
    let weekday_preferences = weekday_preferences_sorted.filter((weekday_pref) => {
      /* check if rule rule can be pruned (null means forever) */
      let ruleEndedBeforeCurrentRange = weekday_pref.valid_before
          ? /*moment.fromRealtimeDB(*/ weekday_pref.valid_before /*)*/ < range_start : false;

      let ruleStartsAfterCurrentRange = weekday_pref.valid_after
          ? /*moment.fromRealtimeDB(*/ weekday_pref.valid_after /*)*/ > range_end : false;

      let canBePruned = ruleEndedBeforeCurrentRange || ruleStartsAfterCurrentRange;
      /* keep = not prune */
      if ( canBePruned ) {
        pruned_weekday_preferences.push(weekday_pref.$id)
      }
      return !( canBePruned );
    });
    // TODO: Save inactive somwhere for later use

    // log("### weekday_preferences (filtered)", weekday_preferences);

    /* deep copy */
    let sumOfHours = 0;
    let event_data = new Array(15000);
    let nrEvents = 0
    //let rank = 0;
    // weekday_preferences = clonedeep( weekday_preferences );

    // DELME: let user_timezone = rootGetters['user/user_get_timezone'];
    // console.log('user_timezone', user_timezone())

    /* loop through the next days until planning horizon */
    //var t0 = performance.now();
    let current_date = moment( range_start ); // CAREFUL! Make copy!
    //console.log('weekday_pref current_date', current_date)
    weekday_preferences.forEach((weekday_pref) => {

      let rangeDayFrom = 0
      if (weekday_pref.valid_after && weekday_pref.valid_after !== null) {
        let valid_after = /*moment.fromRealtimeDB(*/ weekday_pref.valid_after /*)*/
        if (valid_after.isValid()) {
          rangeDayFrom = Math.min( Math.max( valid_after.diff(current_date, 'days'), 0 ) , horizon )
        }
      }

      let rangeDayUntil = horizon
      if (weekday_pref.valid_before && weekday_pref.valid_before !== null) { // TODO: FIX Input for TSCs.. currently broken
        let valid_before = /*moment.fromRealtimeDB(*/ weekday_pref.valid_before /*)*/
        if (valid_before.isValid()) {
          rangeDayUntil = Math.max( Math.min( valid_before.diff(current_date, 'days'), horizon ), 0 ) + 1
        }
      }
      let day_of_week_today = current_date.isoWeekday()

      for (let day_of_week = 1; day_of_week < 8; day_of_week++ ) {

        if ( weekday_pref.selectedWeekdays[day_of_week - 1] === 'x' ) {

          let event_from_time = weekday_pref.from;
          let event_to_time = ( weekday_pref.to ? weekday_pref.to : '24:00' );

          event_from_time = event_from_time.length === 4 ? '0' + event_from_time : event_from_time;
          event_to_time   = event_to_time.length   === 4 ? '0' + event_to_time : event_to_time;
          let date_str = current_date.format('YYYY-MM-DD')
          let current_dateLoopFrom  = moment.fromDateAndTime( date_str, event_from_time )
          let current_dateLoopUntil = moment.fromDateAndTime( date_str, event_to_time )

          let durationMinutes = diff_time(event_to_time, event_from_time).asMinutes()
          let durationHours = diff_time(event_to_time, event_from_time).asHours()

          let dayDifference = 0
          if (day_of_week_today < day_of_week) {
            dayDifference = day_of_week - day_of_week_today
          } else {
            dayDifference = 7 - (day_of_week_today - day_of_week)
          }

          current_dateLoopFrom.add(dayDifference, 'd');
          current_dateLoopUntil.add(dayDifference, 'd');
          let rangeDayFromForWeekday = rangeDayFrom + dayDifference

          for ( let i = rangeDayFromForWeekday; i < rangeDayUntil; i = i + 7 ) {

              /* sum all hours */
              sumOfHours += durationHours;

              /* If weekday should have an event, add a new entry */
              event_data[nrEvents] = {
                from: moment(current_dateLoopFrom), // moment.fromDateAndTime( date_str, event_from_time ),
                // set end time to 24:00 if not set
                to:  moment(current_dateLoopUntil), // moment.fromDateAndTime( date_str, event_to_time ),
                duration: durationMinutes,
                exception: false,
                deleted: false,
                updated: false,
                rule_origin_id: weekday_pref.$id,
                weekday: day_of_week
              };
              //console.log('event added', event_data[nrEvents])
              nrEvents += 1

            current_dateLoopFrom.add(7, 'd');
            current_dateLoopUntil.add(7, 'd');
          }
        }
      }
    })
    //console.log('Events added', event_data)
    //console.log('Events added', nrEvents )
    //var t1 = performance.now();
    //console.log("Measured time " + (t1 - t0) + " milliseconds.")

    // let exception_list = getters.exceptions_by_timeslot_collection_id_sorted(tscId);

    /*
    let exception_list = []
    if ( $models.timeslotException.with({ timeslotCollectionId: tscId }).exists() ) {
      exception_list = $models.timeslotException
        .with({ timeslotCollectionId: tscId })
        .getList()
        .itemsAsArray();
    }
    */

    let exception_list = $models.timeslotException
      .getList()
      .itemsSorted
      .filter(exception => exception.tscId === tscId )

    // exception_list = mapGenericModelListToJSON(exception_list)

    // log("### exception_list", exception_list);

    /* TODO: Some exceptions might have a custom timezone, we need to take care
             of that here! (if exceptions_by_timeslot_collection_id_sorted doesn't) */

    /* prune inactive exceptions */
    // let numOfExceptionsBefore = exception_list.length;
    let pruned_exceptions = [];
    exception_list = exception_list.filter((exception) => {
      let canBePruned = false;
      switch (exception.type) {
        case 'DEL':
        case 'CHG':
        // TODO: gilt nicht für GOOLE CALENDAR!!
        // TODO: TIMESTAMP SHOULD ALREADY BE CONVERTED!?
        canBePruned = /* moment.fromRealtimeDB( */ exception.date /* ) */ < range_start ||
                      /* moment.fromRealtimeDB( */ exception.date /* ) */ > range_end;
        break;

        case 'INS':
        // TODO: What to do if there is a partly overlap?
        // TODO: TIMESTAMP SHOULD ALREADY BE CONVERTED!?
        canBePruned = /* moment.fromRealtimeDB( */ exception.to /* ) */ < range_start ||
                      /* moment.fromRealtimeDB( */ exception.from /* ) */ > range_end;
        break;
      }
      if ( canBePruned ) {
        pruned_exceptions.push(exception.$id)
      }

      /* keep = not prune */
      return  !( canBePruned  );
    });
    // let numOfExceptionsAfter = exception_list.length;
    // console.log("PRUNED n = ", numOfExceptionsBefore - numOfExceptionsAfter, "exceptions");

    exception_list.forEach((exception) => {

      if ( exception.type === 'INS' ) {
        /* sum all hours */
        let exception_from = /* moment.fromRealtimeDB( */ exception.from;
        let exception_to   = /* moment.fromRealtimeDB( */ exception.to;
        let duration = moment.duration(exception_to.diff(exception_from));
        sumOfHours += duration.asHours();

        /* increase rank by 1 */
        //rank += 1;

        /* If weekday should have an event, add a new entry */
        event_data[nrEvents] = {
          weekday:  '?',
          from:      exception_from,
          to:        exception_to,
          duration:  duration.asMinutes(), // TODO: Why string?
          exception: true,
          excId:     exception.$id,
          deleted:   false,
          //rank: rank + ( rank_offset || 0 )
        };
        nrEvents += 1
      }
    })

    event_data = event_data.slice(0, nrEvents) // remove empty elements
    exception_list.forEach((exception) => {
      if ( exception.type === 'DEL' || exception.type === 'CHG' ) {

        let exception_date = exception.date // moment.fromRealtimeDB(exception.date);
        let referenced_event = event_data.find((event) => {
          return event.exception === false &&
            event.rule_origin_id === exception.ref &&
            event.from.format('YYYYMMDD') === exception_date.format('YYYYMMDD');
        })

        if ( referenced_event /* && exception.type === 'DEL' */ ) {
          // log("referenced_event", referenced_event);
          referenced_event.deleted = true;

          /* Keep exception id that deleted this event for later use */
          referenced_event.deleted_by = exception.$id;

          /* Substract duration (in minutes) again */
          sumOfHours -= referenced_event.duration / 60;
        }

        if ( referenced_event && exception.type === 'CHG' ) {
          console.warn("CHG Type is currently not implemented");

          // Das ist eigentlich eine Uhrzeit, BESSER wäre aber hier einfach den
          // Timestamp zu speicher, dann wäre es einfacher:
          referenced_event.from = /* moment.fromRealtimeDB( */ exception.new_from;
          referenced_event.to = /* moment.fromRealtimeDB( */ exception.to_from;
          referenced_event.updated = true;

          /* Estimate time differne old/new event by adding changed time again */
          let duration = moment.duration(referenced_event.to.diff(referenced_event.from));
          sumOfHours += duration.asHours();
        }
      }
    })

    // log("### event_data", event_data);
    //log("Sum of hours for", tscId, "=>", sumOfHours);

    // import store from '@/store'
    // log(store.commit)
    // store.commit('SET_WEEKDAY_PREF_FLAT_CACHE', { tscId, event_data })

    return {
      event_data: event_data,
      aggregated_hours: sumOfHours, // TODO: Why string?
      conflicts: Math.random() > 0.5 ? [] : ['A', 'B'], // HACK, TODO => async promise
      pruned_weekday_preferences: pruned_weekday_preferences,
      partly_pruned_weekday_preferences: Array.from(new Set(partly_pruned_weekday_preferences)),
      pruned_exceptions: pruned_exceptions
    };
  },

  /*
    Returns weekday preferences flattened (from cache)
  */
  get_timeslot_flat_cache_by_tsc_id: state => (tscId) => {
    glog("get_timeslot_flat_cache_by_tsc_id")
    return state.cache.timeslot_flat_cache[tscId] || null;
  },

  /*
  */
  get_timeslot_flat_cache: state => state.cache.timeslot_flat_cache,
}

  /*
    Return the label for a commitmentId
  */
//   timeslot_collection_by_timeslot_collection_id: (state, getters, rootState, rootGetters) =>
//     timeslotCollectionId => {
//
//     let user = rootGetters["user/userData"];
//     // let user = rootState.user.userData;
//     if ( user &&
//       'timeslotCollectionList' in user &&
//       timeslotCollectionId in user.timeslotCollectionList ) {
//       return user.timeslotCollectionList[timeslotCollectionId];
//     }
//     return null;
//
//     /* console.log('Find: timeslotCollectionId', timeslotCollectionId)
//     let timeslotCollection = {}
//     getters.timeslot_collection_list.forEach(timeslotCollectionItem => {
//       if (timeslotCollectionItem.id === timeslotCollectionId) {
//         timeslotCollection = timeslotCollectionItem;
//       }
//     });
//     return timeslotCollection; */
//   },
// };

/* function log() {
  const SKIP_LIST = ['log', 'Object.eval', 'eval', 'Array.map', 'wrappedGetter', 'VueComponent.eval'];
  var sCallerName;
  {
    let re = /([^(]+)@|at ([^(]+) \(/g;
    let aRegexResult = (new Error().stack).match(re).reverse();
    // log("-----------------------------", clonedeep( aRegexResult) );
    do {
      let res = aRegexResult.pop();
      sCallerName = res.substr(3, res.length - 5).trim();
    } while ( SKIP_LIST.includes(sCallerName) || aRegexResult.length === 1 );
  }
  let argumentsArray = [].slice.apply(arguments);
  log('[timeslots/' + sCallerName + ']' + (argumentsArray.length > 0 ? ':' : ''),
    ...argumentsArray);
} */
